<template>
    <v-dialog v-model="showDialog"
              class="hobby-dialog"
              min-width="300"
              width="600"
              transition="dialog-bottom-transition">
        <v-card class="text-primary ma-0">
            <v-card-title>
                <span v-if="edit">{{editTitle}}</span>
                <span v-else>{{createTitle}}</span>
            </v-card-title>

            <v-card-text class="pa-4 py-0">
                <v-form ref="form"
                        @keyup.enter="save"
                        @submit.prevent>
                    <v-text-field class="mt-4"
                                  autofocus
                                  clearable
                                  :label="nameLabel"
                                  :rules="nameRules"
                                  v-model.trim="name" />
                    <v-checkbox class="mb-n8"
                                label="Доступно на улице"
                                v-model="availableOutside" />
                    <v-checkbox class="mb-n4"
                                label="Доступно в помещении"
                                v-model="availableIndoors" />
                </v-form>
            </v-card-text>

            <v-card-actions class="mb-2 mr-2">
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="$emit('hide')">Отменить</v-btn>
                <v-btn color="primary"
                       variant="elevated"
                       :disabled="!isValid"
                       @click="save">Сохранить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        components: {

        },

        props: {
            item: Object,
            items: Array,
            edit: Boolean,
            editTitle: String,
            createTitle: String,
            nameLabel: String
        },

        emits: ["update:item", "hide"],

        data() {
            return {
                showDialog: true,

                id: this.item.id,
                name: this.item.name,
                availableOutside: this.item.availableOutside,
                availableIndoors: this.item.availableIndoors,

                nameRules: [
                    v => !!v || "Нужно ввести название",
                    v => {
                        const item = this.items.find(e => e.name === v);

                        if (!item || item.id === this.id) {
                            return true;
                        }

                        return "Запись с таким названием уже существует";
                    }
                ],

                isValidForm: false
            };
        },

        computed: {
            isComplete() {
                return !!this.name
                    && (this.availableOutside || this.availableIndoors);
            },

            isValid() {
                if (this.isComplete) {
                    this.validateForm();
                }

                return this.isComplete && this.isValidForm;
            }
        },

        watch: {
            showDialog(newValue) {
                if (newValue === false) {
                    this.$emit("hide");
                }
            },

            availableOutside(newValue) {
                this.validateForm();

                if (newValue === false && this.availableIndoors === false) {
                    this.availableIndoors = true;
                }
            },
            availableIndoors(newValue) {
                this.validateForm();

                if (newValue === false && this.availableOutside === false) {
                    this.availableOutside = true;
                }
            }
        },

        methods: {
            async validateForm() {
                if (!this.$refs.form) {
                    return;
                }

                const { valid } = await this.$refs.form.validate();

                this.isValidForm = valid;
            },

            save() {
                if (!this.isValid) {
                    return;
                }

                const item = {
                    id: this.id,
                    name: this.name,
                    availableOutside: this.availableOutside,
                    availableIndoors: this.availableIndoors
                };

                this.$emit("hide");
                this.$emit("update:item", item);
            }
        }
    };
</script>

<style lang="scss">
    .hobby-dialog {
    }
</style>